/**
 * The mentor's view of the batch tutor: every student of the batch, how much
 * each has asked about this module, and any student's conversation, read only.
 */

import React from "react";

import TutorReview from "../Tutor/TutorReview";
import { getStudentTutorHistory, getStudentTutorThreadHistory, getStudentTutorThreads, getTutorStudents } from "./sessionsApi";

export default function StudentQuestions({ sessionId, onSource }) {
  return (
    <TutorReview key={sessionId} onSource={onSource}
      loadStudents={() => getTutorStudents(sessionId)}
      loadChat={(userId, before) => getStudentTutorHistory(sessionId, userId, before)}
      loadThreads={(userId) => getStudentTutorThreads(sessionId, userId)}
      loadThreadChat={(userId, threadId, before) => getStudentTutorThreadHistory(sessionId, userId, threadId, before)} />
  );
}
